import { useEffect } from 'react'
import { useLocation } from 'react-router-dom'
import { logPageView } from '../../lib/analytics'

export function PageViewTracker() {
  const { pathname } = useLocation()

  useEffect(() => {
    logPageView(pathname)
  }, [pathname])

  return null
}
